import cupImage1 from "../../../../../../assets/img/demo/cup1.png";
import {Col, Container, Row} from "react-bootstrap";
import PerformanceAndSkillsScore from "../../../../../ui/player_profile/PlayerDetails/PerformanceAndSkillsScore";
import HonoursAndAchievements from "../../../../../ui/player_profile/PlayerDetails/HonoursAndAchievements";
import TeamAndTransfer from "../../../../../ui/player_profile/PlayerDetails/TeamAndTransfer";
import {gql, useQuery} from "@apollo/client";
import Tools from "../../../../../../Tools";
import React, {Component, Fragment} from "react";
import {connect} from "react-redux";
import CareerStatsTab from "../CareerStatsTab";
import Divider from "../../../../../ui/Divider";
import Loading from "../../../../../ui/feedback/Loading";
import NoError from "../../../../../ui/feedback/NoError";
import PlayedPositionMap from "../../../../../ui/player_profile/PlayerDetails/PlayedPositionMap";
import liverpoolLogo from "../../../../../../assets/img/demo/liverpool-logo.png";

class CareerStatsTabContent extends Component {

    render = () => {
        const {achievements, performance, transfers, positions} = this.props;

        return (
            <Fragment>
                {this.renderOverallCareerStats()}
                <Divider direction="horizontal" size={2} show={true}/>
                <Container fluid={true}>
                    <Row>
                        <Col xl={2} md={6}>
                            <PlayedPositionMap data={positions}/>
                        </Col>
                        <Col xl={5} md={6}>
                            <PerformanceAndSkillsScore data={performance}/>
                        </Col>
                        <Col xl={3} md={12}>
                            <Container fluid={true}>
                                <Row>
                                    <Col xl={12} md={6}>
                                        <HonoursAndAchievements achievements={achievements}/>
                                    </Col>
                                    <Col xl={12} md={6}>
                                        <TeamAndTransfer data={transfers}/>
                                    </Col>
                                </Row>
                            </Container>
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        );
    };

    renderOverallCareerStats = () => {
        const {overallCareerStats} = this.props;

        const items = [
            {title: "Total Matches Played", value: overallCareerStats.matchesPlayed},
            {title: "Total Goals Scored", value: overallCareerStats.goalsScored},
            {title: "Avg Min / Match", value: (overallCareerStats.minutesPlayed / overallCareerStats.matchesPlayed).toFixed(1)},
            {title: "Yellow Card", value: overallCareerStats.yellowCards},
            {title: "Red Card", value: overallCareerStats.redCards},
            {title: "Assists", value: overallCareerStats.assists},
            {title: "Goal Avg / Match", value: (overallCareerStats.goalsScored / overallCareerStats.matchesPlayed).toFixed(1)},
            {title: "Shoot Accuracy", value: `${overallCareerStats.shootAccuracy}%`},
            {title: "Passing Accuracy", value: `${overallCareerStats.passingAccuracy}%`},
            {title: "Tackel sucess rate", value: `${overallCareerStats.tackleSuccessRate}%`},
            {title: "Mental nature", value: overallCareerStats.mentalNature},
        ];

        return (
            <div className="details overall-career-stats">
                <Container fluid={true}>
                    <Row>
                        {items.map((item, index) =>
                            <Col xl={true} lg={2} md={3} sm={4} xs={6} className="information-item--container">
                                <CareerStatsTab.InformationItem key={index} title={item.title} value={item.value}/>
                            </Col>
                        )}
                    </Row>
                </Container>
            </div>

        );
    };
}

const ContentDataWrapper = props => {
    const query = gql`
        query getPlayerDetails ($playerId: String!){
            player: player(id: $playerId){
                ...PlayerFields
            }
        }


        fragment PlayerFields on PlayerModel{
            careerStats{
                season{
                    id
                    name
                }

                matchesPlayed
                goalsScored
                #avgMinMatch Total Min Played / matchesPlayed
                yellowCards
                redCards
                assists
                #avgGoalsMatch Total goals / matchesPlayed
                shootAccuracy
                passingAccuracy
                tackleSuccessRate
                mentalNature

                minutesPlayed
            }

            performance{
                name
                attributes{
                    name
                    value
                }
            }

            transfers{
                teamJoined{
                    name
                    logo
                }
                teamLeft{
                    name
                    logo
                }
                contracts{
                    startAt
                    endAt
                    salary
                }
            }

            achievements{
                #number value: leanght of achievements
                name
                image
                dates{
                    date
                    description
                }
            }

            positions{
                position
                map{
                    location
                    color
                }
            }
        }
    `;

    const formatOverallCareerStats = player => {
        const {careerStats} = player;
        // TODO: Update it.
        return careerStats.filter(item => !item.season)[0];
    };

    const formatPerformance = player => (
        player.performance
    );

    const formatterAchievements = player => (
        player.achievements.map(achievement => ({
            // image: achievement.image, TODO: Replace it
            image: cupImage1,
            count: achievement.dates.length
        }))
    );

    const formatTransfers = player => {
        const currentTeam = player.transfers[0];

        if (!currentTeam?.contracts)
            return null;

        const {contracts} = currentTeam;
        const currentTeamLastContractsDate = contracts?.map(contract => contract.endAt)?.reduce((left, right) => left < right ? left : right);
        const transferredFromTeamValue = contracts?.map(contract => contract.salary)?.reduce((left, right) => left + right);

        const currentTeamDescription = `Contract Expires on ${Tools.convertDateToYearMonth(new Date(currentTeamLastContractsDate))}`;
        const transferredFromTeamDescription = `Transfered for $${Tools.formatterNumber(transferredFromTeamValue)}`;

        return {
            currentTeam: {
                name: currentTeam?.teamJoined?.name,
                description: currentTeamDescription,
                logo: currentTeam?.logo ?? liverpoolLogo, // TODO: Replace with response.
            },
            transferredFrom: {
                name: currentTeam?.teamLeft?.name,
                description: transferredFromTeamDescription,
                logo: currentTeam?.logo ?? liverpoolLogo, // TODO: Replace with response.
            },
        };
    };

    const formatPositions = player => {
        return player.positions;
    };

    const formatter = (player) => ({
        overallCareerStats: formatOverallCareerStats(player),
        performance: formatPerformance(player),
        transfers: formatTransfers(player),
        achievements: formatterAchievements(player),
        positions: formatPositions(player),
    });


    const {playerId} = props;

    const {loading, error, data} = useQuery(query, {
        variables: {
            playerId: playerId
        }
    });

    if (loading) {
        return <Loading.WithWrapper/>;
    } else if (error) {
        return <NoError.WithWrapper error={error}/>;
    }

    const {player} = data;

    return (
        <CareerStatsTabContent {...props} {...formatter(player)}/>
    );
};

const mapStateToProps = (state) => {
    return {
        playerId: state.full_profile.playerId
    }
};

export default connect(mapStateToProps, null)(ContentDataWrapper);
